// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zuiz","fullView":"styles_fullView__1JGdj"};